import { AppSession } from './app-session';

export class LogData {

  static priorityOK        = '141';
  static priorityNOK       = '111';
  static logexecOK         = 'ok';
  static logexecNOK        = 'nok';
  static logexecError      = 'error';
  static logtypePrivate    = 'private';
  static logtypePublic     = 'public';
  static logidenttypeLogin = 'login';
  static logidenttypeIDP   = 'IDP';
  static logidenttypeMail  = 'mail';

  priority: string;
  time: string;
  logapp: string;
  logtype: string;
  logident: string;
  logidenttype: string;
  logtoken: string;
  logexec: string;
  message: string;
  param0: string;
  param1: string;

  public constructor(
    priority: string,
    // time: string,
    // logapp: string,
    logtype: string,
    logident: string,
    logidenttype: string,
    logtoken: string,
    logexec: string,
    messageKey: string,
    param0: string,
    param1: string
  ) {
    this.priority = priority;
    const date: Date = new Date();
    const month = date.toLocaleString('en', { month: 'short' });
    const day = ('0' + date.getUTCDate()).slice(-2);
    const year = date.getUTCFullYear();
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();
    const time = month + ' ' + day + ' ' + year + ' ' + hours + ':' + minutes + ':' + seconds;
    this.time = time;
    this.logapp = (AppSession.getAppPath()).replace('/', '');
    this.logtype = logtype;
    this.logident = logident;
    this.logidenttype = logidenttype;
    this.logtoken = logtoken;
    this.logexec = logexec;
    this.message = messageKey;
    this.param0 = param0;
    this.param1 = param1;
  }
}
